<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-container ref="searchContainer" :scrId="scrId" />
				</sf-card>
			</div>
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<div class="menu-management-content-container h-100">
						<tree-container ref="treeSection" @Refresh="Refresh" :scrId="scrId" />
						<table-container ref="tableSection" @PopupOpen="PopupOpen" @Refresh="Refresh" @RefreshAll="RefreshAll" :onstieScrId="scrId" />
					</div>
				</sf-card>
			</div>
		</div>
		<popup-container ref="popupContainer" @SetName="SetName" :scrId="scrId" />
	</div>
</template>

<script>
import PopupContainer from './Popup/PopupContainer.vue';
import SearchContainer from './Search/SearchContainer.vue';
import TreeContainer from './Tree/TreeContainer.vue';
import TableContainer from './Table/TableContainer.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { SearchContainer, TreeContainer, TableContainer, PopupContainer },
	methods: {
		PopupOpen(param) {
			this.$refs.popupContainer.open(param);
		},
		SetName(param) {
			// console.log('@@@@ emit call')
			// console.log(param)
			if (param != null) {
				this.$refs.tableSection.setMenuName(param);
			}
		},
		Refresh(currentPage = 1, pageUnit = 10) {
			this.$refs.searchContainer.searchList(currentPage, pageUnit);
		},
		RefreshAll() {
			this.Refresh();
			this.$refs.treeSection.setTreeList();
		}
	}
};
</script>

<style scoped>
.menu-management-content-container {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}
</style>
